import React, { useState, useRef, useEffect, useMemo } from 'react';
import {Boxdataset} from '../ui_components/boxdataset';

const OverviewTopSection = ({ analyticsData, boxClickFunction }) => {

    const processedData = useMemo(() => {
        if (!analyticsData?.current) {
            return {
                revenue: 0,
                revenue_comparison: 0,
                revenue_change: 0
            };
        }

        // {
        //     "new_members": 2138,
        //     "revenue": 123112,
        //     "lease_cost": 21824,
        //     "employee": 25344,
        //     "foot_traffic": 25014,
        //     "avg_family_size": 2.987103448275862,
        //     "avg_net_worth": 143717.5379310345,
        //     "avg_rev_per_member": 9.655931034482759,
        //     "avg_number_visits": 1.9575172413793103,
        //     "max_members_total": 6305,

        // }

        const currentData = analyticsData.current;
        const comparisonPeriod = analyticsData.comparison;
        const revenue_comparison = comparisonPeriod.revenue
        const employee_comparison = comparisonPeriod.employee
        const lease_comparison = comparisonPeriod.lease_cost
        const foot_traffic_comparison = comparisonPeriod.foot_traffic
        const new_members_comparison = comparisonPeriod.new_members
        const max_members_total_comparison = comparisonPeriod.max_members_total
        const avg_number_visits_comparison = Math.round(comparisonPeriod.avg_number_visits * 100) / 100
        const avg_rev_per_member_comparison = Math.round(comparisonPeriod.avg_rev_per_member * 100) / 100;

        // console.log('currentData: ', currentData, comparisonPeriod)

        const revenue_change = revenue_comparison ? Math.round(((currentData.revenue - revenue_comparison) / revenue_comparison) * 100) / 100 : null;
        const employee_change = employee_comparison ? Math.round(((currentData.employee - employee_comparison) / employee_comparison) * 100) / 100 : null;
        const lease_change = lease_comparison ? Math.round(((currentData.lease_cost - lease_comparison) / lease_comparison) * 100) / 100 : null;
        const foot_traffic_change = foot_traffic_comparison ? Math.round(((currentData.foot_traffic - foot_traffic_comparison) / foot_traffic_comparison) * 100) / 100 : null;

        const new_members_change = new_members_comparison ? Math.round(((currentData.new_members - new_members_comparison) / new_members_comparison) * 100) / 100 : null;
        const max_members_total_change = max_members_total_comparison ? Math.round(((currentData.max_members_total - max_members_total_comparison) / max_members_total_comparison) * 100) / 100 : null;
        const avg_number_visits_change = avg_number_visits_comparison ? Math.round(((currentData.avg_number_visits - avg_number_visits_comparison) / avg_number_visits_comparison) * 100) / 100 : null;
        const avg_rev_per_member_change = avg_rev_per_member_comparison ? Math.round(((currentData.avg_rev_per_member - avg_rev_per_member_comparison) / avg_rev_per_member_comparison) * 100) / 100 : null;


        return {
            revenue: '$' + currentData.revenue,
            employee: '$' + currentData.employee,
            lease: '$' + currentData.lease_cost,
            foot_traffic: currentData.foot_traffic,
            new_members: currentData.new_members,
            max_members_total: currentData.max_members_total,
            avg_number_visits: Math.round(currentData.avg_number_visits * 100) / 100,
            avg_rev_per_member: '$' + Math.round(currentData.avg_rev_per_member * 100) / 100,

            revenue_comparison: '$' + revenue_comparison,
            employee_comparison: '$' + employee_comparison,
            lease_comparison: '$' + lease_comparison,
            foot_traffic_comparison,
            new_members_comparison,
            max_members_total_comparison,
            avg_number_visits_comparison,
            avg_rev_per_member_comparison: '$' + avg_rev_per_member_comparison,

            revenue_change,
            lease_change,
            employee_change,
            foot_traffic_change,
            new_members_change,
            max_members_total_change,
            avg_number_visits_change,
            avg_rev_per_member_change

        };
    }, [analyticsData]);

//   console.log('analyticsData: ', analyticsData)
  return (
    <>
      <div className='mb-50 mt-50'>
        <h2 className='mb-20 font-weight600 data-component'>Overview</h2>
        <div className='display-flex gap-20  h-140 display-flex-column-800'>
            <div className='flex-1 center-content'>
                <div className='width-100 min-w-240' >
                <Boxdataset boxClickFunction={boxClickFunction} classnameval={`box-container ${!processedData.revenue && 'pb-70'} cursor-pointer`} exportInd={false} starredval={true} margin={154} unsetarrangement={()=>{}} setarrangement={()=>{}} zoom={0} arrangement={1} arrangestar={true} top_text='Revenue' mid_text="Revenue" total_diff={processedData.revenue_change} total_current={processedData.revenue} total_past={processedData.revenue_comparison} type={true} description="Total revenue for the locations" filters={{}}/>
                </div>
            </div>

            <div className='flex-1 center-content'>
                <div className='width-100 min-w-240'>
                    <Boxdataset boxClickFunction={boxClickFunction}  negativeGood={true} classnameval={`box-container ${!processedData.lease && 'pb-70'} cursor-pointer`} exportInd={false} starredval={true} margin={154} unsetarrangement={()=>{}} setarrangement={()=>{}} zoom={0} arrangement={1} arrangestar={true} top_text='Lease Cost' mid_text="Lease Cost" total_diff={processedData.lease_change} total_current={processedData.lease} total_past={processedData.lease_comparison} type={true} description="Leasing cost for the locations" filters={{}}/>
                </div>
            </div>

            <div className='flex-1 center-content'>
                <div className='width-100 min-w-240'>
                    <Boxdataset boxClickFunction={boxClickFunction}  negativeGood={true} classnameval={`box-container ${!processedData.employee && 'pb-70'} cursor-pointer`} exportInd={false} starredval={true} margin={154} unsetarrangement={()=>{}} setarrangement={()=>{}} zoom={0} arrangement={1} arrangestar={true} top_text='Employee Cost' mid_text="Employee Cost" total_diff={processedData.employee_change} total_current={processedData.employee} total_past={processedData.employee_comparison} type={true} description="Employee Cost as reported" filters={{}}/>
                </div>
            </div>
            
            <div className='flex-1 center-content'>
                <div className='width-100 min-w-240'>
                    <Boxdataset boxClickFunction={boxClickFunction}  classnameval={`box-container ${!processedData.foot_traffic && 'pb-70'} cursor-pointer`} exportInd={false} starredval={true} margin={154} unsetarrangement={()=>{}} setarrangement={()=>{}} zoom={0} arrangement={1} arrangestar={true} top_text='Est. Foot Traffic' mid_text="Est. Foot Traffic" total_diff={processedData.foot_traffic_change} total_current={processedData.foot_traffic} total_past={processedData.foot_traffic_comparison} type={true} description="Estimate total number of visitors to the stores" filters={{}}/>
                </div>
            </div>
        </div>

      </div>




      <div className='mb-50 mt-50'>
        <h2 className='mb-20 font-weight600 data-component'>Loyalty Members</h2>
        <div className='display-flex gap-20  h-140 display-flex-column-800'>
            <div className='flex-1 center-content'>
                <div className='width-100 min-w-240'>
                <Boxdataset boxClickFunction={boxClickFunction}  classnameval={`box-container ${!processedData.revenue && 'pb-70'} cursor-pointer`} exportInd={false} starredval={true} margin={154} unsetarrangement={()=>{}} setarrangement={()=>{}} zoom={0} arrangement={1} arrangestar={true} top_text='New Members' mid_text="New Members" total_diff={processedData.new_members_change} total_current={processedData.new_members} total_past={processedData.new_members_comparison} type={true} description="Total number of new members in the given time frame and locations" filters={{}}/>
                </div>
            </div>

            <div className='flex-1 center-content'>
                <div className='width-100 min-w-240'>
                    <Boxdataset boxClickFunction={boxClickFunction}  classnameval={`box-container ${!processedData.revenue && 'pb-70'} cursor-pointer`} exportInd={false} starredval={true} margin={154} unsetarrangement={()=>{}} setarrangement={()=>{}} zoom={0} arrangement={1} arrangestar={true} top_text='Total Members' mid_text="Total Members" total_diff={processedData.max_members_total_change} total_current={processedData.max_members_total} total_past={processedData.max_members_total_comparison} type={true} description="Total number of loyalty members at the end of the given timeframe" filters={{}}/>
                </div>
            </div>

            <div className='flex-1 center-content'>
                <div className='width-100 min-w-240'>
                    <Boxdataset boxClickFunction={boxClickFunction}  classnameval={`box-container ${!processedData.revenue && 'pb-70'} cursor-pointer`} exportInd={false} starredval={true} margin={154} unsetarrangement={()=>{}} setarrangement={()=>{}} zoom={0} arrangement={1} arrangestar={true} top_text='Average Transaction Value' mid_text="Average Transaction Value" total_diff={processedData.avg_rev_per_member_change} total_current={processedData.avg_rev_per_member} total_past={processedData.avg_rev_per_member_comparison} type={true} description="Average revenue per loyalty member" filters={{}}/>
                </div>
            </div>
            
            <div className='flex-1 center-content'>
                <div className='width-100 min-w-240'>
                    <Boxdataset boxClickFunction={boxClickFunction}  classnameval={`box-container ${!processedData.revenue && 'pb-70'} cursor-pointer`} exportInd={false} starredval={true} margin={154} unsetarrangement={()=>{}} setarrangement={()=>{}} zoom={0} arrangement={1} arrangestar={true} top_text='Average Number of Visits' mid_text="Average Number of Visits" total_diff={processedData.avg_number_visits_change} total_current={processedData.avg_number_visits} total_past={processedData.avg_number_visits_comparison} type={true} description="Average of how many times a loyalty member visited" filters={{}}/>
                </div>
            </div>
        </div>

      </div>
    </>
  );
};

export default OverviewTopSection;